import {
  HomeFeaturedTime,
  HomeFilterContentType,
  HomeGenderState,
  HomePopularTime,
  HomeSorting,
} from 'Types/character'
import { atom } from 'recoil'
import { TagID } from 'Types/tag'
import {
  localStorageWriteStringEffect,
  localStorageWriteJsonEffect,
} from 'Store/util'
import { storageKey } from '@/constant/storage'

export const homeSortingState = atom<HomeSorting>({
  key: 'homeSortingState',
  default: 'For You',
  effects: [localStorageWriteStringEffect('homeSortingState')],
})

export const DEFAULT_NSFW = false
// ⚠️ 同步逻辑在别处：本 atom 只写 localStorage、不回读，刷新后会回落到 DEFAULT_NSFW。
// NSFW（Limitless）开关的权威源是后端 user.nsfw，由 hooks/useInit.tsx 监听 user.nsfw
// 统一播种（含从 localStorage 水合、登录、后端刷新场景）。改动二者任一方前请同时检查另一处，
// 误删 useInit 里那段会导致「删了 homeNSFWState 缓存或刷新后开关被关」的 bug 复发。
export const homeNSFWState = atom<boolean>({
  key: 'homeNSFWState',
  default: DEFAULT_NSFW,
  effects: [localStorageWriteStringEffect('homeNSFWState')],
})

export const homeTimeState = atom<HomePopularTime>({
  key: 'homeTimeState',
  default: '7d', // 改为 '7d'
  effects: [localStorageWriteStringEffect('homeTimeState')],
})

export const homeFeaturedTimeState = atom<HomeFeaturedTime>({
  key: 'homeFeaturedTimeState',
  default: '7d',
  effects: [localStorageWriteStringEffect('homeFeaturedTimeState')],
})

export const homeGenderState = atom<HomeGenderState>({
  key: 'homeGenderState',
  default: 'All',
  effects: [localStorageWriteStringEffect('homeGenderState')],
})

export const homeSelectedTagIdsState = atom<TagID[]>({
  key: 'homeSelectedTagIdsState',
  default: [],
})

export const homeSelectedContentTypesState = atom<HomeFilterContentType[]>({
  key: 'homeSelectedContentTypesState',
  default: [],
})

export const homeFilterDrawerOpenState = atom<boolean>({
  key: 'homeFilterDrawerOpenState',
  default: false,
})

export const homeTagExpandedState = atom<boolean>({
  key: 'homeTagExpandedState',
  default: false,
})

export const homeMobilePageState = atom<'screen' | 'grid'>({
  key: 'homeMobilePageState',
  default: 'grid',
})

// PaddingBottom解决tag的shadow被容器截断的问题，
const tagCollapsedOriginalHeight = 36
const tagTotalPaddingBottom = 10
export const tagPaddingTop = 6
export const tagPaddingBottom = 6
export const tagContainerPaddingBottom =
  tagTotalPaddingBottom - tagPaddingBottom
export const tagCollapsedHeight =
  tagCollapsedOriginalHeight + tagPaddingTop + tagPaddingBottom
export const homeTagHeightState = atom<number>({
  key: 'homeTagHeightState',
  default: tagCollapsedHeight,
})

// 是否已经展示过万圣节 Tag 弹窗（首次进入显示）
export const hasHalloweenTagPopupShownState = atom<boolean>({
  key: 'hasHalloweenTagPopupShownState',
  default: false,
  effects: [localStorageWriteJsonEffect(storageKey.HALLOWEEN_TAG_POPUP_SHOWN)],
})

// 首页筛选图标是否显示红点
export const showFilterBadgeState = atom<boolean>({
  key: 'showFilterBadgeState',
  default: true,
  effects: [localStorageWriteJsonEffect(storageKey.SHOW_FILTER_BADGE)],
})

// 已点击过的带红点tag列表
export const clickedTagsWithBadgeState = atom<string[]>({
  key: 'clickedTagsWithBadgeState',
  default: [],
  effects: [localStorageWriteJsonEffect(storageKey.CLICKED_TAGS_WITH_BADGE)],
})
